module.exports = __webpack_public_path__ + "media/Video 106.4a35a07e.mp4";